
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FiliaisEditComponent } from './components/filiais-edit/filiais-edit.component';
import { FiliaisComponent } from './filiais/filiais.component';

const routes: Routes = [
  {
    path: '',
    component: FiliaisComponent,
  },
  {
    path: ':id',
    component: FiliaisEditComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FiliaisRoutingModule { }
